export default __webpack_public_path__ + "b9d2f2d0fa7ecc78d69af76083b8f30a.png";